const SET_CATEGORIES = "SET_CATEGORIES";
const SET_CATEGORY = "SET_CATEGORY";

export { SET_CATEGORIES, SET_CATEGORY };
